import $ from 'jquery';

const InventoryMovements = {
  bindDeltaCalculator() {
    $(`.new-total`).change((event) => {
      const $changed = $(event.currentTarget);
      const $changedRow = $($changed.closest(`tr`));
      const newTotal = $changed.val();
      const onHand = $($changedRow.find(`.on-hand`)[0]).text();

      return $($changedRow.find(`.delta`)[0]).val(newTotal - onHand);
    });
  },

  init() {
    if ($(`#new-inventory-update`).length === 0) {
      return;
    }
    this.bindDeltaCalculator();
  },
};

export default InventoryMovements;
